import React from 'react';
import LabelWithSiblings from './label-with-siblings';

function LabelWithInfo({ text, info, tooltipPlacement }) {
    return (
        <LabelWithSiblings
            siblingsMask="LI"
            labelContent={text}
            tooltipContent={info}
            tooltipPlacement={tooltipPlacement}
        />
    );
}

export default LabelWithInfo;
